import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import Center from "./Center";
import useForm from "../hooks/useForm";
import { createAPIEndpoint, ENDPOINTS } from "../api";
import useStateContext from "../hooks/useStateContext";
import { useNavigate } from "react-router";
import logo from "../assets/images/logo.png";
import {
  LogindisabledMesage,
  EmailAlreadyExistsErrorMessage,
  InvalidEmailErrorMessage,
  QuizStartedErrorMessage,
  RequiredFieldErrorMessage,
} from "../constants/constant";

const getFreshModel = () => ({
  name: "",
  email: "",
});

export default function Login() {
  const { context, setContext, resetContext } = useStateContext();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");

  const { values, setValues, errors, setErrors, handleInputChange } =
    useForm(getFreshModel);
  const [examStart, setexamStart] = useState(false);

  useEffect(() => {
    resetContext();
  }, []);

  const login = (e) => {
    e.preventDefault();
    if (validate())
      createAPIEndpoint(ENDPOINTS.participant)
        .post(values)
        .then((res) => {
          setContext(res.data);
          setErrorMessage("");
          navigate("/quiz", { state: { user: res.data } });
        })
        .catch((err) => {
          console.log(err.response, "userinfoerror");
          if (
            err.response &&
            err.response.status === 400 &&
            err.response.data ===
              "Participant with the same name and email already exists"
          ) {
            // Handle 400 Bad Request error (email already exists)
            setErrorMessage(EmailAlreadyExistsErrorMessage);
          } else if (
            err.response &&
            err.response.status === 400 &&
            err.response.data === "Exam is currently in progress. Please Wait"
          ) {
            // Handle 400 Bad Request error (email already exists)
            setErrorMessage(QuizStartedErrorMessage);
          } else {
            console.log(err);
          }
        });
  };

  const validate = () => {
    let temp = {};
    temp.email = /\S+@\S+\.\S+/.test(values.email)
      ? ""
      : InvalidEmailErrorMessage;
    temp.name = values.name !== "" ? "" : RequiredFieldErrorMessage;
    setErrors(temp);
    return Object.values(temp).every((x) => x === "");
  };

  useEffect(() => {
    createAPIEndpoint(ENDPOINTS.getStartExam)
      .getStartExam()
      .then((res) => {
        setexamStart(res.data.examstart);
      })
      .catch((err) => {
        console.log(err);
      });

    return () => {
      clearInterval();
    };
  }, []);

  return (
    <>
      {!examStart ? (
        <Center>
          <Card
            sx={{
              width: 400,
              backgroundColor: "white",
              border: "3px solid",
              borderImage: "linear-gradient(to right, #fc4906, #fc0d5e)",
              borderImageSlice: 1,
              "@media (max-width: 576px)": {
                // Apply styles for screens with a minimum width of 600px
                width: "auto",
                marginX: "10px",
              },
            }}
          >
            <CardContent sx={{ textAlign: "center", paddingBottom: "20px" }}>
              <Typography variant="h3" sx={{ my: 3 }}>
                <img src={logo} alt="logo" style={{ width: "200px" }} />
              </Typography>
              <Box
                sx={{
                  "& .MuiTextField-root": {
                    m: 1,
                    width: "90%",
                  },
                }}
              >
                <form noValidate autoComplete="off" onSubmit={login}>
                  <TextField
                    label="Email"
                    name="email"
                    value={values.email}
                    onChange={handleInputChange}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& input": {
                          color: "black", // Change the input text color
                        },
                        "& fieldset": {
                          borderImage:
                            "linear-gradient(to right, #fc480678, #fc0d5d7b)", // Gradient border color
                          borderImageSlice: 1, // Ensure the gradient covers the entire border
                        },
                        "&:hover fieldset": {
                          borderImage:
                            "linear-gradient(to right, #fc480678, #fc0d5d7b)",
                          borderImageSlice: 1, // Gradient border color on hover
                        },
                        "&.Mui-focused fieldset": {
                          borderImage:
                            "linear-gradient(to right, #fc480678, #fc0d5d7b)",
                          borderImageSlice: 1, // Gradient border color when focused
                        },
                      },
                    }}
                    variant="outlined"
                    borderColor="green"
                    InputLabelProps={{
                      style: { color: "black", borderColor: "black" },
                    }}
                    {...(errors.email && {
                      error: true,
                      helperText: errors.email,
                    })}
                  />
                  <TextField
                    label="Name"
                    name="name"
                    value={values.name}
                    onChange={handleInputChange}
                    variant="outlined"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& input": {
                          color: "black", // Change the input text color
                        },
                        "& fieldset": {
                          borderImage:
                            "linear-gradient(to right, #fc480678, #fc0d5d7b)", // Gradient border color
                          borderImageSlice: 1, // Ensure the gradient covers the entire border
                        },
                        "&:hover fieldset": {
                          borderImage:
                            "linear-gradient(to right, #fc480678, #fc0d5d7b)",
                          borderImageSlice: 1, // Gradient border color on hover
                        },
                        "&.Mui-focused fieldset": {
                          borderImage:
                            "linear-gradient(to right, #fc480678, #fc0d5d7b)",
                          borderImageSlice: 1, // Gradient border color when focused
                        },
                      },
                    }}
                    InputLabelProps={{
                      style: { color: "black", borderColor: "black" },
                    }}
                    {...(errors.name && {
                      error: true,
                      helperText: errors.name,
                    })}
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    sx={{
                      marginTop: "15px",
                      marginBottom: "5px",
                      padding: "8px 0",
                      borderRadius: "20px",
                      width: "35%",
                      color: "white",
                      transition: "background 0.2s ease-in-out",
                      background: "linear-gradient(to right, #fc4906, #fc0d5e)",
                      "&:hover": {
                        background: "#fc4906",
                      },
                    }}
                  >
                    Start
                  </Button>
                </form>
                {errorMessage && (
                  <Typography variant="body2" color="error" sx={{ mt: 2 }}>
                    {errorMessage}
                  </Typography>
                )}
              </Box>
            </CardContent>
          </Card>
        </Center>
      ) : (
        <Center>
          <div className="login-container" style={{ textAlign: "center" }}>
            <Typography variant="h3" sx={{ my: 1 }}>
              <img
                src={logo}
                alt="logo"
                style={{ width: "200px", textAlign: "center" }}
              />
            </Typography>
            <h1 className="heading">{LogindisabledMesage}</h1>
          </div>
        </Center>
      )}
    </>
  );
}
